<script setup>
    import { ElCollapseItem, ElTree, ElButton, ElInput } from 'element-plus';
    import { ref } from 'vue';
    import { Delete, DCaret, Plus } from '@element-plus/icons-vue';
    import { storeToRefs } from 'pinia';
    import { useProductStore } from '../../stores/fpe';
    import DownloadFile from '../utility/download-file.vue'
    import { ArrowRightBold } from '@element-plus/icons-vue'
    const store = useProductStore();
    const { product, data_sets, strings } = storeToRefs(store);

    // check if downloadable
    const isDownloadable = ref(false);

    if(product.value.type == 'simple' && product.value.downloadable == true && fpe.editor_config.pro){
        isDownloadable.value = true;
    }

    const deleteDownload = (id) => {
        const index = product.value.downloads.findIndex((download) => download.$treeNodeId === id);
        product.value.downloads.splice(index, 1);
    }


</script>

<template>
    <el-collapse-item v-if="isDownloadable" :title="strings.section_title_downloads" class="fpe-section-downloads" name="downloads" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="downloads">
            <label>{{ strings.label_downloadable_files }}</label>
            <el-tree
                :data="product.downloads"
                node-key="hash"
                default-expand-all
                :expand-on-click-node="false"
                draggable
                class="fpe-download-files"
                :icon="DCaret"
                >
                <template #default="{ node, data }">
                    <DownloadFile v-model="product.downloads" :node="node" :data="data" :product="product" @ondelete="deleteDownload" />
                </template>
            </el-tree>
            <ElButton class="fpe-add-download-row" type="plain" :icon="Plus" @click="product.downloads.push({})">Add File</ElButton>
        </div>
 
        <div class="fpe-field-wrapper" data-field="download-limit">
            <label>{{ strings.label_download_limit }}</label>
            <ElInput type="number" v-model="product.download_limit" />
        </div>

        <div class="fpe-field-wrapper" data-field="download-expiry">
            <label>{{ strings.label_download_expiry }}</label>
            <ElInput type="number" v-model="product.download_expiry" />
        </div>
        

    </el-collapse-item>    

</template>